<template>
  <v-avatar :size="size || 40">
    <img
      style="width: 100%;
            height: 100%;
            object-fit: cover;"
      v-if="idProfessional"
      v-bind:src="avatarUrl"
    />
    <v-icon color="gray" v-else>mdi-account</v-icon>
  </v-avatar>
</template>

<script>
export default {
  name: "professional-avatar",
  props: ["idProfessional", "size"],
  computed: {
    avatarUrl() {
      const base = process.env.VUE_APP_API_URL || 'https://gestion.clinicaorlandi.cl/api-clientes/1';
      return base + '/getProfessionalAvatar?idProfessional=' + this.idProfessional;
    }
  }
};
</script>